const MenuHeader = () => {
    return (
        <div className="dropdown-menu-header flex items-center justify-between px-[0.938rem] py-3 border-b border-b-geyser">
            <h6 className="dropdown-menu-title mb-0 text-[14px] text-primary font-semibold">
                Chats
            </h6>
            <div className="dropdown-menu-links text-base text-primary font-body">

            </div>
        </div>
    );
};

export default MenuHeader;
